/**
 * Farm moduli API qatlami (web).
 *
 * MUHIM: loyihaning asosiy axios instance'i /api/v1/ ga bog'langan,
 * farm esa /api/farm/ prefiksida — shuning uchun alohida instance.
 * humps transformlari asosiy request.js bilan bir xil:
 * javob snake_case -> camelCase, so'rov camelCase -> snake_case.
 */
import axios from 'axios'
import humps from 'humps'
import { useCallback, useEffect, useState } from 'react'
import { domain } from '../../urls'
import { auth } from '../../utils/auth'

const farmAxios = axios.create({
    baseURL: `${domain}/api/farm/`,
    transformResponse: [
        ...axios.defaults.transformResponse,
        humps.camelizeKeys,
    ],
    transformRequest: [
        (data) => (data && typeof data === 'object' ? humps.decamelizeKeys(data) : data),
        ...axios.defaults.transformRequest,
    ],
})

farmAxios.interceptors.request.use((config) => ({
    ...config,
    params: humps.decamelizeKeys(config.params),
}))

/** Bitta so'rov: farmRequest({ url, method, data, params }) */
export async function farmRequest(options) {
    const { data } = await farmAxios({ ...auth(), ...options })
    return data
}

/** Sahifalangan ro'yxatni to'liq (barcha sahifalar) oladi. */
export async function farmList(url, params = {}) {
    const all = []
    let page = 1
    // DRF sahifasi: { count, results }
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        const data = await farmRequest({ url, params: { ...params, page } })
        if (Array.isArray(data)) return data
        all.push(...(data.results || []))
        if (all.length >= (data.count || 0) || !(data.results || []).length) break
        page += 1
    }
    return all
}

/** GET hook: { data, loading, error, reload } */
export function useFarmLoad(url, params = {}, deps = []) {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const load = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            setData(await farmRequest({ url, params }))
        } catch (e) {
            setError(e.response || { status: 0 })
        } finally {
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)

    useEffect(() => { load() }, [load])
    return { data, loading, error, reload: load }
}

/** Ro'yxat hook (barcha sahifalar): { items, loading, error, reload } */
export function useFarmList(url, params = {}, deps = []) {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const load = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            setItems(await farmList(url, params))
        } catch (e) {
            setError(e.response || { status: 0 })
        } finally {
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)

    useEffect(() => { load() }, [load])
    return { items, loading, error, reload: load }
}

/** So'm formatlash: 1500000 -> "1 500 000" */
export function fmtMoney(value) {
    if (value === null || value === undefined) return '—'
    return new Intl.NumberFormat('ru-RU').format(Math.round(Number(value)))
}

export function fmtNum(value, digits = 1) {
    if (value === null || value === undefined) return '—'
    return Number(value).toLocaleString('ru-RU', { maximumFractionDigits: digits })
}
